// src/pages/CreateAgencyForm.jsx
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Select, InputNumber, message } from "antd";
import { createAgency } from "../api/agencyApi";
import { getBrands } from "../api/brandApi";

const { Option } = Select;

const CreateAgencyForm = ({ onSuccess, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const [brands, setBrands] = useState([]);

  // Cargar marcas para el select "Marca Dealer"
  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await getBrands();
        setBrands(response.data);
      } catch (error) {
        console.error("Error fetching brands:", error);
        message.error("Error al obtener las marcas");
      }
    };
    fetchBrands();
  }, []);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await createAgency(values);
      message.success("Agencia creada exitosamente");
      onSuccess(); // Notificar al padre para refrescar la lista y cerrar el modal
    } catch (error) {
      console.error("Error creando agencia:", error);
      message.error("Error al crear la agencia");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 600 }}>
      <Form layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Agencia"
          name="name"
          rules={[
            { required: true, message: "Ingresa el nombre de la agencia" },
          ]}
        >
          <Input placeholder="Ej: Loja" />
        </Form.Item>

        <Form.Item
          label="Empresa"
          name="company"
          rules={[
            { required: true, message: "Ingresa el nombre de la empresa" },
          ]}
        >
          <Input placeholder="Ej: AYASA - NISSAN" />
        </Form.Item>

        <Form.Item
          label="Marca Dealer"
          name="brandId"
          rules={[{ required: true, message: "Selecciona la marca dealer" }]}
        >
          <Select placeholder="Selecciona la marca dealer">
            {brands.map((brand) => (
              <Option key={brand.id} value={brand.id}>
                {brand.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Provincia"
          name="province"
          rules={[{ required: true, message: "Ingresa la provincia" }]}
        >
          <Input placeholder="Ej: Loja" />
        </Form.Item>

        <Form.Item
          label="Ciudad"
          name="city"
          rules={[{ required: true, message: "Ingresa la ciudad" }]}
        >
          <Input placeholder="Ej: Loja" />
        </Form.Item>

        <Form.Item
          label="Dirección"
          name="address"
          rules={[{ required: true, message: "Ingresa la dirección" }]}
        >
          <Input placeholder="Ej: Av. Cuxibamba y Tulcán" />
        </Form.Item>

        <Form.Item
          label="Latitud"
          name="latitude"
          rules={[{ required: true, message: "Ingresa la latitud" }]}
        >
          <InputNumber style={{ width: "100%" }} placeholder="-3.98634" />
        </Form.Item>

        <Form.Item
          label="Longitud"
          name="longitude"
          rules={[{ required: true, message: "Ingresa la longitud" }]}
        >
          <InputNumber style={{ width: "100%" }} placeholder="-79.2054" />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Crear Agencia
          </Button>
          <Button onClick={onCancel} style={{ marginLeft: 8 }}>
            Cancelar
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default CreateAgencyForm;
